import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IPostVehicle } from '../../../../shared/services/vehicle/vehicle.model';
import VehicleService from '../../../../shared/services/vehicle/vehicle.service';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { VehicleForm } from '../../../presentation-components/organisation-components/vehicle-form';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import moment from 'moment';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const OrganisationVehicleNewPage = () => {
  const navigate = useNavigate();
  //Services
  const vehicleService = VehicleService.getInstance()
  const userNotificationsContext = useContext(UserNotificationsContext)
  const userDetailsContext = useContext(UserDetailsContext)
  const reportPeriodContext = useContext(ReportPeriodContext)
  const organisationId = userDetailsContext.userDetails?.organisation.id
  const screenLabelsContext = useContext(ScreenLabelsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>()
  const [newVehicle, setNewVehicle] = useState<IPostVehicle>({
    vinNumber: '',
    organisationId: organisationId || '',
    subsidiaryId: '',
    customUniqueId: '',
    dataEntryPeriod: '',
    vehicleType: '',
    assignedUserId: null,
    startDate: moment(
      reportPeriodContext.allReportPeriods.find(r => r.id === reportPeriodContext.lastSelectedReportId)?.startDate
      ?? moment()
    ).format('YYYY-MM-DD HH:mm:ss.SSS Z'),
    endDate: undefined,
    ownership: '',
    vehicleReference: '',
    customFieldValues: [],
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)

  const submitHandler = async (newVehicleForm: IPostVehicle) => {
    if (!isFormSubmitting) {
      setIsFormSubitting(true)
      vehicleService.create(newVehicleForm)
        .then(response => {
          refreshVehiclesandRedirect(response.id);
        })
        .catch(err => {
          setIsFormSubitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  function refreshVehiclesandRedirect(newVehicleId: string | undefined): void {
    vehicleService.getAllVehicles(true)
      .then(() => {
        setIsFormSubitting(false)
        userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
        if (newVehicleId) {
          navigate(`/organisation/vehicles/${newVehicleId}`)
        } else {
          navigate("/organisation/vehicles")
        }
      })
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New ${screenLabelsContext.getLabel('vehicle', { plural: false, capitalize: 'first' })}`}
        includeBackButton={true}
        backButtonLink='/organisation/vehicles'
        backButtonText={`Back to ${screenLabelsContext.getLabel('vehicle', { plural: true })}`}
      />
      <VehicleForm
        newVehicle={newVehicle}
        submitHandler={submitHandler}
        isSubmitting={isFormSubmitting}
        errorMessage={errorMessage}
        errorCode={errorCode} />
    </PageOuterContainer>
  )
}